import React, {useState} from "react";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import Link from "next/link";
import Button from "@/components/button";


export default function ThankYouPage() {
  return <DefaultLayout
    title="Create Listing | Lazy Prompts"
    description="Sell your AI prompts on Lazy Prompts."
    light
  >
    <section className={`light ${css.thanks}`}>
      <div className="sectionInner">
        <h2>Listing Under Review!</h2>
        <p>Your listing has been received and is now under review. Thank you for selling on Lazy Prompts.</p>
        <p>You do not need to take any further action. If your listing meets our terms of service and quality standards, it will automatically be made available on the Lazy Prompts marketplace. You can check your <Link href="/account/listings">Store Overview</Link> page to see whether your prompt has been approved or not.</p>
        <div className={css.buttons}>
          <Button label="Home" href="/" ghost/>
          <Button label="List More" href="/account/listings/create"/>
        </div>
      </div>
    </section>
  </DefaultLayout>;
}
